import { render, staticRenderFns } from "./PrestationsRegard.vue?vue&type=template&id=4a02d094&"
import script from "./PrestationsRegard.vue?vue&type=script&lang=js&"
export * from "./PrestationsRegard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports